"use client";
import { LandingBlogGetListOutputApiModel } from "@/Apis/ClinicApi";
import { SmartImage, SmartLink } from "@/Components";
import { useRouter } from "@/Components/AppProgressBar";
import { Pagination, Space } from "antd";
import moment from "moment-jalaali";
import { usePathname, useSearchParams } from "next/navigation";
import { FC } from "react";
import { FaRegCalendarAlt } from "react-icons/fa";

interface LandingBlogListPageProps {
  result: LandingBlogGetListOutputApiModel;
  current: number;
  pageSize: number;
}

const LandingBlogListPage: FC<LandingBlogListPageProps> = ({
  result,
  current,
  pageSize,
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const paging = result.Paging;
  const total = paging.TotalCount;
  const pagesCount = paging.PagesCount;

  const onChange = (page: number) => {
    const sp = new URLSearchParams(searchParams?.toString());
    sp.set("page", String(page));
    router.push(`${pathname}?${sp.toString()}`);
  };

  return (
    <>
      <div className="row blog-grid-row">
        {result.Paging.Items?.map((item) => (
          <div key={item.Id} className="col-md-6 col-sm-12">
            {/* Blog Post */}
            <div className="blog grid-blog">
              <div className="blog-image">
                <SmartLink href={item.Link}>
                  <SmartImage
                    cover
                    className="img-fluid"
                    src={item.ImageUrl}
                    alt={item.Title}
                    width={374}
                    height={242}
                  />
                </SmartLink>
                <span className="badge badge-cyan category-slug">
                  {item.CategoryName}
                </span>
              </div>
              <div className="blog-content">
                <ul className="entry-meta meta-item">
                  {item.CenterUserAuthorId && item.CenterUserAuthorFullName && (
                    <li>
                      <div className="post-author">
                        <SmartLink href={item.CenterUserAuthorLink}>
                          <Space>
                            {item.CenterUserAuthorImageUrl && (
                              <SmartImage
                                cover
                                src={item.CenterUserAuthorImageUrl}
                                alt={item.CenterUserAuthorFullName}
                                width={24}
                                height={24}
                              />
                            )}
                            <span>{item.CenterUserAuthorFullName}</span>
                          </Space>
                        </SmartLink>
                      </div>
                    </li>
                  )}
                  <li>
                    <FaRegCalendarAlt className="me-1" />
                    {moment(item.DateRegister).format("jDD jMMMM jYYYY")}
                  </li>
                </ul>
                <h3 className="blog-title">
                  <SmartLink href={item.Link}>{item.Title}</SmartLink>
                </h3>
                <p className="mb-0">{item.ContentShort}</p>
              </div>
            </div>
            {/* /Blog Post */}
          </div>
        ))}
      </div>
      {/* Blog Pagination */}
      <div className="row">
        <div className="col-md-12 text-center">
          {/* Pagination */}
          <Pagination
            className="d-inline-block"
            current={current}
            pageSize={pageSize}
            total={total}
            onChange={onChange}
            showQuickJumper={pagesCount ? pagesCount > 7 : true}
          />
          {/* /Pagination */}
        </div>
      </div>
      {/* /Blog Pagination */}
    </>
  );
};

export default LandingBlogListPage;
